module.exports = __webpack_public_path__ + "img/art-57.1b956aa9.png";